// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-M":"M_power-ocean-home-M__i8gl1"};